import { render, staticRenderFns } from "./locpoint.vue?vue&type=template&id=fdfc9b5a&scoped=true"
import script from "./locpoint.vue?vue&type=script&lang=js"
export * from "./locpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdfc9b5a",
  null
  
)

export default component.exports